import React from "react";
import ReactDOM from "react-dom";
import SortingVisualizer from "./SortingVisualizer/SortingVisualizer.jsx";

// ## Rendering SortingVisualizer Component ( Imported from path mentioned above ) ## //
ReactDOM.render(<SortingVisualizer />, document.getElementById("root"));
